"use strict";

export { GestureDetectorType } from './common';
export { GestureDetector } from './GestureDetector';
export { InterceptingGestureDetector } from './VirtualDetector/InterceptingGestureDetector';
export { VirtualDetector as VirtualGestureDetector } from './VirtualDetector/VirtualDetector';
//# sourceMappingURL=index.js.map